import styled from "styled-components";

interface WrapperProps {
    isCalloutExists?: boolean;
}

export const Wrapper = styled.div<WrapperProps>(props => ({
    position: "relative",
    marginTop: props.isCalloutExists ? `calc(${props.theme.spacing.xLarge} * -1)` : props.theme.spacing.xSmall,
    marginBottom: props.isCalloutExists ? `${props.theme.spacing.large}` : props.theme.spacing.empty,
    zIndex: 3,
}));

export const CarouselWrapper = styled.div(({ theme }) => ({
    marginLeft: `calc(${theme.spacing.medium} * -1)`,
    marginRight: `calc(${theme.spacing.medium} * -1)`,
    overflowX: "hidden",
}));

interface DotIndicatorProps {
    isActive?: boolean;
}

export const DotIndicator = styled.div<DotIndicatorProps>(({ isActive }) => ({
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    marginRight: "3px",
    left: "177px",
    backgroundColor: isActive ? "rgba(2, 2, 2, 0.34)" : "#D2D2D2",
}));

export const DotWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center", // Center the dots horizontally
    marginTop: `calc(${theme.spacing.small} * -1)`,
}));
